// this is an autogenerated file from DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Postal/Addresses/Content/Address/Edit/Content/Fields/City/Cities/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_DataVaxiomRelationshipsItem_Edit_NonPatient_Postal_Addresses_Content_Address_Edit_Content_Fields_City_Cities($search_term: String) {
  cities(
    where: { city: { _ilike: $search_term } }
    limit: 20
    order_by: { city: asc }
    distinct_on: city
  ) {
    id: city
    value: city
  }
}

`